var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBank = function SvgIconBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.476 2.148a1 1 0 0 1 1.048 0l9.75 6A1 1 0 0 1 21.75 10h-2v4.75H21a1 1 0 1 1 0 2H3a1 1 0 1 1 0-2h1.25V10h-2a1 1 0 0 1-.524-1.852zM17.75 10v4.75h-2.5V10zm-4.5 0v4.75h-2.5V10zm-4.5 0v4.75h-2.5V10zm9.467-2H5.783L12 4.174z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 18.5a1 1 0 1 0 0 2h21a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconBank;